// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"356af833","120":"76e59364","453":"c62bf3bd"}[chunkId] + ".chunk.js";
};